module.exports = __webpack_public_path__ + "img/su.0ac02993.jpg";